export default "__VITE_ASSET__ZnutGb7p__"